import { ITheme } from "./theme.type";

export const theme: ITheme = {
  colors: {
    bg: {
      mainBg: "#F8F8F8",
      whiteBg: "#ffffff",
      blue: "#259eb1",
      darkBlue: "#259eb1",
      mainLightBg: "#F6F6F9",
    },
    text: {
      lightBlack: "#313949",
      black: "#000000",
      red: "red",
      blue: "#259eb1",
      white: "#ffffff",
    },
    color: {
      blue: "#259eb1",
      black: "#000000",
      lightBlack: "#333333",
      red: "red",
      lightGrey: "#EDF1FF",
    },
    border: {
      grey: "rgba(49, 57, 73, 0.1)",
      red: "red",
      lightBlack: "#ccc",
    },
    button: {
      blue: "#259eb1",
      red: "red",
    },
  },
};
